/**
 * Reference to the buyer of the floor rate option through its trade side.
 * tag: 40801
 * @readonly
 * @enum {number} (int)
 */
export enum PaymentStreamFloorRateBuySide {
  /** Buyer of the trade */
  Buyer = 1,
  /** Seller of the trade */
  Seller = 2,
}
